import { Dialog } from "@mui/material";
import React from "react";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";

const InfoDialog = ({ title, desc, content, show, onClose }) => {
  console.log("sksksk");
  return (
    <Dialog open={show} onClose={onClose}>
      {/* The backdrop, rendered as a fixed sibling to the panel container */}
      <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
      {/* Full-screen container to center the panel */}
      <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
        <Dialog.Panel className="mx-auto w-[70%] rounded h-[70vh] bg-white p-6 overflow-y-auto flex flex-col">
          <div className="mb-8">
            <Dialog.Title className={"text-2xl text-center font-bold mb-6"}>
              {title || "Title"}
            </Dialog.Title>
            <Dialog.Description
              className={"text-2xl text-center font-bold mb-6"}
            >
              {desc}
            </Dialog.Description>

            <Markdown remarkPlugins={[remarkGfm]}>{content}</Markdown>
          </div>

          <div className="w-full flex  justify-center">
            <div
              onClick={onClose}
              className="bg-slate-200 p-3 max-w-[100px] flex justify-center items-center m-4 cursor-pointer mt-auto"
            >
              Close
            </div>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
};

export default InfoDialog;
